import Modal from 'react-modal';
import { useQuery } from '@tanstack/react-query';

import { FilterMenu } from '@components/listing';
import { RightModal } from '@components/ui';

Modal.setAppElement('#__next');

const getFilters = async () => {
    const res = await fetch(
        `https://api-prod.ferventeshop.com/api/v1/meta/filter-attributes`,
    );
    const data = await res.json();
    return data;
};

const FilterModal = ({
    filterModalIsOpen,
    onCloseFilterModal,
    productCount,
}) => {
    const { data, isLoading } = useQuery(['filters'], getFilters, {
        enabled: filterModalIsOpen,
    });

    return (
        <RightModal
            isOpen={filterModalIsOpen}
            closeModal={onCloseFilterModal}
            noOverlay
            width="400px"
        >
            {!isLoading && (
                <FilterMenu
                    onModalClose={onCloseFilterModal}
                    filters={data?.data}
                    productCount={productCount}
                />
            )}
        </RightModal>
    );
};

export default FilterModal;
